/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvY2FuZGlkYXRlL2NvbXBvbmVudHMvY2FuZGlkYXRlLWVtZXJnZW5jeS1jb250YWN0L2NhbmRpZGF0ZS1lbWVyZ2VuY3ktY29udGFjdC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvbW9kdWxlcy9jYW5kaWRhdGUvY29tcG9uZW50cy9jYW5kaWRhdGUtZW1lcmdlbmN5LWNvbnRhY3QvY2FuZGlkYXRlLWVtZXJnZW5jeS1jb250YWN0LmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/candidate/components/candidate-emergency-contact/candidate-emergency-contact.component.scss.shim.ngstyle.ts